<template>
  <!-- 物业项目信息目录审批 -->
  <div style="width: 100%;padding-top: 60px">
    <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="项目详情" name="1">
        <van-field label="公司名称" v-model="inputForm.companyName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="物业服务处名称" v-model="inputForm.deptName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="物业项目名称" v-model="inputForm.projectName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="是否启用" label-width='100px' v-model="inputForm.isEnabledName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="备注" v-model="inputForm.remarks" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
      <van-collapse-item title="项目基本情况" name="2">
        <van-field label="案名" v-model.trim="inputForm.wuyeBaseProjectInfoDTO.caseName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="路名" v-model.trim="inputForm.wuyeBaseProjectInfoDTO.streetName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="项目竣工日期" v-model="inputForm.wuyeBaseProjectInfoDTO.completionDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="入伙收楼日期" v-model="inputForm.wuyeBaseProjectInfoDTO.inHouseDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="总建筑面积（㎡）" v-model="inputForm.wuyeBaseProjectInfoDTO.allArea" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="总幢数" v-model="inputForm.wuyeBaseProjectInfoDTO.allBuilding" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="总单元数" v-model="inputForm.wuyeBaseProjectInfoDTO.allCells" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="总户数" v-model="inputForm.wuyeBaseProjectInfoDTO.allHouse" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="独立别墅栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.dlbsds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="独立别墅户数" v-model="inputForm.wuyeBaseProjectInfoDTO.dlbshs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="双联别墅栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.slbsds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="双联别墅户数" v-model="inputForm.wuyeBaseProjectInfoDTO.slbshs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="互联别墅栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.hlbsds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="互联别墅户数" v-model="inputForm.wuyeBaseProjectInfoDTO.hlbshs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="高层栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.gcds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="高层户数" v-model="inputForm.wuyeBaseProjectInfoDTO.gchs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="小高层栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.xgcds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="小高层户数" v-model="inputForm.wuyeBaseProjectInfoDTO.xgchs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="多层栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.dcds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="多层户数" v-model="inputForm.wuyeBaseProjectInfoDTO.dchs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="办公楼栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.bglds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="办公楼户数" v-model="inputForm.wuyeBaseProjectInfoDTO.bglhs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="商铺栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.spds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="商铺户数" v-model="inputForm.wuyeBaseProjectInfoDTO.sphs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="会所栋数" v-model="inputForm.wuyeBaseProjectInfoDTO.hsds" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="会所户数" v-model="inputForm.wuyeBaseProjectInfoDTO.hshs" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面储藏室数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.wareHouseNumUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面储藏室面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.wareHouseAreaUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下储藏室数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.wareHouseNumDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下储藏室面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.wareHouseAreaDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面产权式汽车库数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.carHouseNumUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面产权式汽车库面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.carHouseAreaUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下产权式汽车库数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.carHouseNumDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下产权式汽车库面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.carHouseAreaDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面停车位数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.parkingSpaceNumUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面停车位面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.parkingSpaceAreaUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下停车位数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.parkingSpaceNumDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下停车位面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.parkingSpaceAreaDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面公建配套房屋数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.publicBuildingNumUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地面公建配套房屋面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.publicBuildingAreaUp" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下公建配套房屋数量(间)" v-model="inputForm.wuyeBaseProjectInfoDTO.publicBuildingNumDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="地下公建配套房屋面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.publicBuildingAreaDown" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="绿化总面积(㎡)" v-model="inputForm.wuyeBaseProjectInfoDTO.greenArea" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
<!--      <van-collapse-item title="附件信息" name="3" v-show="inputForm.wuyeBaseProjectInfoDTO.attachList.length > 0">-->
<!--        <a style="display: block;" :key="index" v-for="(file,index) in inputForm.wuyeBaseProjectInfoDTO.attachList"-->
<!--           :href="file.url">{{ file.name }}</a>-->
<!--      </van-collapse-item>-->
      <div style="padding-left: 16px;" v-show="inputForm.wuyeBaseProjectInfoDTO.attachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.wuyeBaseProjectInfoDTO.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import {queryById, startFlow} from '../../api/base/wuyeProjectInfo'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: '',
  data() {
    return {
      isshow: false,
      activeNames: ['1', '2', '3'],
      inputForm: {
        id: '',
        wuyeBaseProjectInfoDTO: {
          id: '',
          policeNo: '',
          completionDate: '',
          inHouseDate: '',
          allArea: '',
          allBuilding: '',
          allCells: '',
          allHouse: '',
          wareHouseNumUp: '',
          wareHouseNumDown: '',
          wareHouseAreaUp: '',
          wareHouseAreaDown: '',
          carHouseNumUp: '',
          carHouseNumDown: '',
          carHouseAreaUp: '',
          carHouseAreaDown: '',
          parkingSpaceNumUp: '',
          parkingSpaceNumDown: '',
          parkingSpaceAreaUp: '',
          parkingSpaceAreaDown: '',
          publicBuildingNumUp: '',
          publicBuildingNumDown: '',
          publicBuildingAreaUp: '',
          publicBuildingAreaDown: '',
          greenArea: '',
          remarks: '',
          attachList: [],
          isDoTask: false,
          isLastTask: false,
        },
        companyId: '',
        companyName: '',
        deptId: '',
        deptName: '',
        projectName: '',
        sortNo: '',
        isEnabled: '1',
        remarks: ''
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  mounted() {
  },
  components: {
    processRecord
  },
  props: {},
  computed: {},
  watch: {},
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({ data }) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>


</style>